<template>
  <!---全体を囲む--->
  <div>
    <!-- メイン画面 -->
    <div v-if="isReadyToDraw" class="content-wrapper">
      <!-- 施設情報表示 -->
      <TheFacilityCard
        v-if="car_share.Station"
        :background-img-u-r-l="car_share.Image"
        :list-item1="car_share.Corporation.Name"
        :list-item3="car_share.Station.Name"
        :button1-action="goToPlaceCarShare"
        :button2-action="goToDetailCarShare"
      />
      <!-- 施設情報表示 -->

      <!-- index画面の描画ローディング -->
      <ItemDialogForIndexPage v-else />
    </div>
    <!-- メイン画面 -->

    <!-- isReadyToDrawがtrueになるまで -->
    <FacePhraseForIndexPage
      v-else
      phrase="周辺にご案内できる施設はありません"
    />
  </div>
  <!---全体を囲む--->
</template>

<script>
import { mapGetters } from "vuex";

window.jcSetCarShareInfo = function (info) {
  storeJS.commit("car_share/setCarShare", info);
};
export default {
  async mounted() {
    if (this.$store.getters["common/device"] == "BROWSER") {
      try {
        const info = await this.$store.dispatch("car_share/getCarShare", {
          geo: "35.65,139.44",
        });
        await window.jcSetCarShareInfo(info);
      } catch (err) {
        await window.jcSetCarShareInfo("");
      }
    } else {
      // 周辺・カーシェア・レンタカーでページ描画完了をマップWebviewへ知らせる関数
      this.ncPageReady();
    }
  },
  methods: {
    goToPlaceCarShare() {
      this.ncGotoPlaceCarShare(this.car_share);
    },
    async goToDetailCarShare() {
      await this.ncSetPlaceInfoCarShare(this.car_share);
      await this.$router.push({
        name: "CarShareDetail",
        params: {
          index: 0,
        },
        query: { language: this.$store.getters["common/lang"] },
      });
    },
  },
  computed: {
    isReadyToDraw() {
      return this.car_share;
    },
    ...mapGetters("car_share", ["car_share"]),
  },
};
</script>
